// File: frontend/src/components/app/ProtectedRoute.js

import { Navigate, useLocation } from 'react-router-dom';

/**
 * Protected route component.
 *
 * Renders children when a real user object is loaded. While auth is still
 * resolving (token in localStorage, useAuth fetching /me) we keep rendering
 * children so AppContent's own LoadingScreen shows — otherwise we'd flash
 * the login page for every authed user on a cold load.
 *
 * The current path rides along as ?next= so LoginPage can return the user
 * here instead of the default /app/ destination.
 */
function ProtectedRoute({ children, user, isLoading }) {
  const location = useLocation();
  if (!user && !isLoading) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  return children;
}

export default ProtectedRoute;
